import { useEffect, useState } from 'react';
import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import authApi from './api/auth';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { useAppDispatch, useAppSelector } from './hooks/useRedux';
import Dashboard from './pages/Dashboard/Dashboard';
import { Categories } from './pages/General Management/Categories';
import { AddHobby } from './pages/General Management/Categories/AddHobby';
import { AddSkill } from './pages/General Management/Categories/AddSkill';
import { AddSubject } from './pages/General Management/Categories/AddSubject';
import Legal from './pages/General Management/Legal';
import { AddPrivacyPolicy } from './pages/General Management/Legal/AddPrivacyPolicy';
import { AddTerms } from './pages/General Management/Legal/AddTerms';
import { Pricing } from './pages/General Management/Pricing';
import Login from './pages/Login/Login';
import ManageTutors from './pages/Tutor-Management/Manage';
import TutorRequests from './pages/Tutor-Management/Requests';
import TutorRequestPage from './pages/Tutor-Management/Requests/TutorRequestPage';
import { login } from './reducers/authSlice';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-toastify/dist/ReactToastify.css';
import StudentAttendance from './pages/Student-Management/Manage/Attendance';
import StudentPlanAttendance from './pages/Student-Management/Manage/Attendance/PlanAttendance';
import StudentCalendar from './pages/Student-Management/Manage/Calendar';
import StudentDashboard from './pages/Student-Management/Manage/Dashboard';
import StudentPlans from './pages/Student-Management/Manage/Plans';
import StudentProfile from './pages/Student-Management/Manage/Profile';
import StudentTransactions from './pages/Student-Management/Manage/Transactions';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false // default: true
    }
  }
});

import 'react-toastify/dist/ReactToastify.css';
import EditCategory from './pages/General Management/Categories/EditCategories';
import ManageStudents from './pages/Student-Management/Manage';
import TutorPage from './pages/Tutor-Management/Manage/TutorPage';
import ComingSoon from './pages/ComingSoon';
import Bookings from './pages/Plan Management/Bookings';
import ChangeRequest from './pages/Plan Management/Change Requests';
import ViewPlan from './pages/Plan Management/Bookings/ViewPlan';
import Earnings from './pages/Earnings-Management';
import Disputes from './pages/Class Management/Disputes';
import ClassManagement from './pages/Class Management/Classes';
import Dispute from './pages/Class Management/Disputes/Dispute';
import GeneralEnquiry from './pages/Enquiry Management/General';
import SupportEnquiries from './pages/Enquiry Management/Support';
import Enquiry from './pages/Enquiry Management/Enquiry';
import TutorDashboard from './pages/Tutor-Management/Manage/Dashboard';
import { TutorCalendar } from './pages/Tutor-Management/Manage/Calendar';
import TutorEarnings from './pages/Tutor-Management/Manage/Earnings';
import TutorAttendance from './pages/Tutor-Management/Manage/Attendance';
import TutorPlanAttendance from './pages/Tutor-Management/Manage/Attendance/PlanAttendance';
import TutorPlans from './pages/Tutor-Management/Manage/MyPlans';
import TutorStudents from './pages/Tutor-Management/Manage/Students';
import BookTrailDashboard from './pages/booktrails';
import PaymentDetailsDashboard from './pages/paymentDetail';
import Curriculum from './pages/Curriculum/Curriculum';
import AddSubjectDetail from './pages/Curriculum/components/AddSubjectDetail';
import RaiseTicket from './pages/RaiseTicket';
import TicketDetail from './pages/RaiseTicket/TicketDetail';
import SummerCampEnquiries from './pages/AI-Summer-Camp/Enquire';
import SummerCampEnquiryDetail from './pages/AI-Summer-Camp/Enquire/EnquiryDetail';
import SummerCampRegistrations from './pages/AI-Summer-Camp/RegisterCamp';
import RegistrationDetail from './pages/AI-Summer-Camp/RegisterCamp/RegistrationDetail';
import Registrations from './pages/Registrations';
import RegistrationDetailPage from './pages/Registrations/RegistrationDetail';

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    authApi
      .authStatus()
      .then((data) => {
        dispatch(login(data));
      })
      .catch((err) => err);
  }, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={<ComingSoon />} />

            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="/tutor-management">
                <Route index element={<ManageTutors />} />
                <Route path="requests" element={<TutorRequests />} />
                <Route path="requests/:tutor_id" element={<TutorRequestPage />} />
                <Route path="manage" element={<ManageTutors />} />
                <Route path="manage/:tutor_id" element={<TutorDashboard />}>
                  <Route path="profile" element={<TutorPage />} />
                  <Route path="calendar" element={<TutorCalendar />} />
                  <Route path="earnings" element={<TutorEarnings />} />
                  <Route path="attendance" element={<TutorAttendance />} />
                  <Route path="students" element={<TutorStudents />} />
                  <Route path="plans" element={<TutorPlans />} />
                  <Route path="plans/:planId/attendance" element={<TutorPlanAttendance />} />
                </Route>
              </Route>

              <Route path="/student-management">
                <Route index element={<ManageStudents />} />
                <Route path=":student_id" element={<StudentDashboard />}>
                  <Route path="profile" element={<StudentProfile />} />
                  <Route path="plans" element={<StudentPlans />} />
                  <Route path="plans/:planId/attendance" element={<StudentPlanAttendance />} />
                  <Route path="calendar" element={<StudentCalendar />} />
                  <Route path="attendance" element={<StudentAttendance />} />
                  <Route path="transactions" element={<StudentTransactions />} />
                </Route>
              </Route>
              <Route path="/class-management">
                <Route index element={<ClassManagement />} />
                <Route path="classes" element={<ClassManagement />} />
                <Route path="disputes" element={<Disputes />}>
                  <Route path=":session_id" element={<Dispute />} />
                </Route>
              </Route>
                  
            <Route path='/summer-camp/enquiries'>
              <Route index element={<SummerCampEnquiries />} />
              <Route path=':enquiryId' element={<SummerCampEnquiryDetail />} />
            </Route>
            <Route path='/summer-camp/camp-registrations'>
              <Route index element={<SummerCampRegistrations />} />
              <Route path=':paymentId' element={<RegistrationDetail />} />
            </Route>
              <Route path="/book-trial">
                <Route index element={<BookTrailDashboard />} />
              </Route>

              <Route path='/registrations'>
                <Route index element={<Registrations />} />
                <Route path=':registrationId' element={<RegistrationDetailPage />} />
              </Route>

              <Route path="/earning-payment">
                <Route index element={<PaymentDetailsDashboard />} />
              </Route>

              <Route path="/enquiry-management">
                <Route index element={<GeneralEnquiry />} />
                <Route path="general" element={<GeneralEnquiry />}>
                  <Route path=":enquiryId" element={<Enquiry />} />
                </Route>
                <Route path="support" element={<SupportEnquiries />}>
                  <Route path=":enquiryId" element={<Enquiry />} />
                </Route>

                <Route path="ticket-raise" element={<RaiseTicket />} />
                <Route path="ticket-raise/:ticketId" element={<TicketDetail />} />
              </Route>
              {/* Curriculum */}

              <Route path="/curriculum">
                <Route index element={<Curriculum />} />
                <Route path="/curriculum/add-subject" element={<AddSubjectDetail />} />
                <Route path="/curriculum/update/:slug" element={<AddSubjectDetail />} />
              </Route>

              <Route path="/earnings-management" element={<Earnings />} />

              <Route path="/general-management" element={<General />}>
                <Route index element={<Categories />} />
                <Route index path="categories" element={<Categories />} />
                <Route path="/general-management/categories/addSubject" element={<AddSubject />} />
                <Route path="/general-management/categories/addHobby" element={<AddHobby />} />
                <Route path="/general-management/categories/addSkill" element={<AddSkill />} />

                <Route path="/general-management/categories/:_id" element={<EditCategory />} />
                <Route path="/general-management/:_id" element={<EditCategory />} />

                <Route path="/general-management/pricing" element={<Pricing />} />
                <Route path="/general-management/legal" element={<Legal />} />
                <Route path="/general-management/legal/terms-conditions" element={<AddTerms />} />
                <Route path="/general-management/legal/privacy-policy" element={<AddPrivacyPolicy />} />
              </Route>
              <Route path="/plan-management">
                <Route index element={<Bookings />} />
                <Route index path="bookings" element={<Bookings />} />
                <Route index path=":plan_id" element={<ViewPlan />} />
                <Route index path="bookings/:plan_id" element={<ViewPlan />} />
                <Route index path="change-requests/:plan_id" element={<ViewPlan />} />
                <Route index path="change-requests" element={<ChangeRequest />} />
              </Route>
            </Route>

          </Routes>
        </Router>
      </QueryClientProvider>
    </>
  );
}

const General = () => {
  return <Outlet />;
};

const Layout = () => {
  const { admin } = useAppSelector((state) => state.authSlice);
  const [open, setOpen] = useState(true);

  if (!admin.id) {
    return <Navigate to={'/login'} />;
  }

  return (
    // <div className="w-full h-full flex bg-slate-100">
    //   <div className="grow sticky">
    //     <Sidebar />
    //   </div>
    //   <div className="w-full h-full flex flex-col gap-1">
    //     <Header />
    //     <div className="w-full min-h-screen flex flex-col gap-1 ">
    //       <div className="w-full h-full bg-slate-100 py-4 px-2">
    //         <BreadCrumb />
    //       </div>
    //       <div className="w-full h-full grow flex bg-white p-2 ">
    //         <div className="w-full grow flex flex-col ml-2 mt-5 p-4 bg-white drop-shadow-lg">
    //           <Outlet />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    //   <ToastContainer position="bottom-right" theme="light" />
    // </div>
    <div className="w-full h-full">
      <section className="w-full relative  mx-auto h-full grid grid-cols-[repeat(32,minmax(40px,500px))]">
        <div
          className={`${open ? 'col-span-6' : 'col-span-1'} w-full max-h-screen overflow-y-auto min-h-screen sticky top-0`}
        >
          <Sidebar open={open} setOpen={setOpen} />
        </div>
        <div className={`w-full ${open ? 'col-[7_/_span_26]' : 'col-[2_/_span_31]'} h-full`}>
          <div className="w-full h-full flex flex-col gap-1 top-0">
            <Header />
            <div className="w-full min-h-screen flex flex-col gap-1">
              {/* <div className="w-full bg-slate-100 py-4 px-2">
                <BreadCrumb />
              </div> */}
              <div className="px-4 ">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="bottom-right" theme="light" />
      </section>
    </div>
  );
};

export default App;
